module.exports = __webpack_public_path__ + "static/img/default_short_video.80de01f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/default_short_video.jpg
// module id = Ck36
// module chunks = 0